<template>
    <div class="container">
        <img :src="iconUrl" class="icon" :style="{ height: `${this.sizeIcon}px` }" :alt="$t('alt.icone')" />
        <div class="text-container">
            <h3 class="title">{{ this.title }}</h3>
        </div>
        <div v-if='modeEdition'>
            <img :src="iconFiltre" class="arrow" :alt="$t('alt.filtre')" @click='emitFiltre'/>
            <img :src="iconDupliquer" class="arrow" :alt="$t('alt.dupliquer')" @click='emitDupliquer'/>
            <img :src="iconBin" class="arrow" :alt="$t('alt.supprimer')" @click='emitSuppression'/>
        </div>
        <img :src="loadArrow" class="arrow" :alt="$t('alt.fleche')" />
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        iconUrl: { type: String, required: true },
        sizeIcon: Number,
        title: { type: String, required: true },
        modeEdition: { type: Boolean, required: false },
    },
    computed: {
        loadArrow() {
            return require('@/assets/img/arrow-right.svg');
        },
        iconBin() {
            return require('@/assets/img/icons/bin.png');
        },
        iconFiltre() {
            return require('@/assets/img/icons/filter.png');
        },
        iconDupliquer() {
            return require('@/assets/img/icons/dupliquer.png');
        }
    },
    methods: {
        emitFiltre() {
            this.$emit('filtre');
        },
        emitDupliquer() {
            this.$emit('dupliquer');
        },
        emitSuppression() {
            this.$emit('suppression');
        }
    },
});
</script>

<style scoped>
.container {
    background-color: var(--white);
    display: flex;
    align-items: center;
    padding: 5px;
    height: 55px;
    cursor: pointer;
}
.text-container {
    flex: 1;
    margin-left: 10px;
    font-size: var(--font-size-low-medium);
    font-weight: var(--font-weight-300);
}
.title {
    font-family: 'Raleway Semi Bold', sans-serif;
    font-variant-numeric: lining-nums;
    font-size: var(--font-size-medium);
    margin: 0 0 3px 0;
    color: var(--color-principal);
}
@media screen and (max-height: 700px) {
    .title {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 350px;
    }

    .text-container {
        overflow: hidden;
    }
}
.icon {
    height: 36px;
    margin: 0 3px 0 7px;
}
.arrow {
    height: 21px;
    margin-right: 7px;
}
</style>
